/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Personalsignonchrstimascardfromid7Inputs */

const de__field_personalsignonchrstimascardfromid7 = /** @type {(inputs: _Field_Personalsignonchrstimascardfromid7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weihnachtkarte personalisiert durch ID`)
};

/**

* @param {_Field_Personalsignonchrstimascardfromid7Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_personalsignonchrstimascardfromid7 = /** @type {((inputs?: _Field_Personalsignonchrstimascardfromid7Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Personalsignonchrstimascardfromid7Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_personalsignonchrstimascardfromid7(inputs)
});
export { _field_personalsignonchrstimascardfromid7 as "_field_personalSignOnChrstimasCardFromID" }